import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../Services/Api/ApiServices";

export const GetAllFieldsManager = createAsyncThunk(
  "GetAllFieldsManager/GetAllFieldsManager",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDownsManager/GetAllFieldsManager",
        parameters
      );

      const data = response.data.result;
      console.log(data, "app");
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const AllFieldsManager = createSlice({
  name: "AllFieldsManager",
  initialState: {
    AllFieldsManager: [],
    loadingAllFieldsManager: false,
    errorAllFieldsManager: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllFieldsManager.pending, (state, action) => {
        state.loadingAllFieldsManager = true;
        state.AllFieldsManager = action.payload;
        state.errorAllFieldsManager = null;
      })
      .addCase(GetAllFieldsManager.fulfilled, (state, action) => {
        state.loadingAllFieldsManager = false;
        state.AllFieldsManager = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllFieldsManager.rejected, (state, action) => {
        state.loadingAllFieldsManager = false;
        state.errorAllFieldsManager = action.payload;
      });
  },
});

export default AllFieldsManager.reducer;
